document.addEventListener('DOMContentLoaded', function() {
    const monthCircles = document.querySelectorAll('.month-circle');
    const monthlyDetails = document.querySelectorAll('.monthly-detail-content');
  
    // 初期表示
    const initialMonth = 5; // 現在の月（5月）を初期表示
    monthlyDetails.forEach(detail => detail.classList.remove('is-active'));
    monthCircles.forEach(circle => circle.classList.remove('is-active'));
  
    const initialDetail = document.querySelector(`.monthly-detail-content[data-month="${initialMonth}"]`);
    const initialCircle = document.querySelector(`.month-circle[data-month="${initialMonth}"]`);
  
    if (initialDetail) {
      initialDetail.classList.add('is-active');
    }
    if (initialCircle) {
      initialCircle.classList.add('is-active');
    }
  
    // 月の円がクリックされた時の処理
    monthCircles.forEach(circle => {
      circle.addEventListener('click', function() {
        const selectedMonth = this.dataset.month;
  
        // 全ての詳細コンテンツと月の円を非アクティブにする
        monthlyDetails.forEach(detail => detail.classList.remove('is-active'));
        monthCircles.forEach(c => c.classList.remove('is-active'));
  
        // クリックされた月の円に対応するコンテンツと月の円をアクティブにする
        const targetDetail = document.querySelector(`.monthly-detail-content[data-month="${selectedMonth}"]`);
        if (targetDetail) {
          targetDetail.classList.add('is-active');
        }
        this.classList.add('is-active');
      });
    });
  });